export default __webpack_public_path__ + "static/media/guna_homes_team_guna_form.a66d75c8.png";